export default __webpack_public_path__ + "974444e3321be8a06c058fe9ce9d16a8.svg";